<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium" label-suffix="：">
          <el-form-item label="日期">
            <el-date-picker :picker-options="pickerOptions" v-model="searchForm.SEND_DAY" type="date" placeholder="选择日期"
              :clearable="false" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doQueryTable()" :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="TC_NAME" label="团餐公司"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="产品备注"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="数量"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="价格"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="USER_NAME" label="申请人"></el-table-column>
          <el-table-column prop="CELLPHONE" label="电话"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="dataY(scope.row)">通过</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      tableData: [],
      loadSearch: false,
      searchForm: {
        SEND_DAY: date(new Date(), '%F'),
      },
      pickerOptions: {
        disabledDate(time) {
          const nowD = new Date();
          return time.getTime() < nowD.getTime() - 3600 * 1000 * 24;
        },
      },
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    doQueryTable() {
      this.queryData();
    },
    queryData() {
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 13,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
      }
      this.loadSearch = true;
      http.post(params).then((result) => {
        this.loadSearch = false;
        this.tableData = result;
      }).catch((error) => {
        this.loadSearch = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    dataY(row) {
      this.$confirm('确定通过审核吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10004',
          OTYPE: 14,
          DETAIL_ID: row.DETAIL_ID,
        };
        http.post(params).then(() => {
          this.$message.show({ text: '审核通过', type: 'success' });
          this.queryData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ text: '操作取消', type: 'info' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sellOrderManage/remarksReview.vue